import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessagesOutletComponent } from '@pressteaze/ui';

@Component({
	imports: [RouterModule, MessagesOutletComponent],
	selector: 'app-root',
	templateUrl: './app.html',
	styleUrl: './app.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
